import React, { useState } from "react";
import { InvoiceForm } from "./invoiceForm";
import { ConfirmationForm } from "./confirmationForm";
import { NavPage } from "../models/NavPage";
import { IPaymentResponse } from "../api";

export interface AppProps {
  baseUrl: string;
  clientId: string;
  merchantCode: string;
  securePaySrc: string;
}

export const App = (props: AppProps) => {
  const [receipt, setReceipt] = useState<IPaymentResponse>({});
  const [page, setPage] = useState(NavPage.Payment);

  return (
    <>
      {page === NavPage.Payment && (
        <InvoiceForm
          clientId={props.clientId}
          merchantCode={props.merchantCode}
          securePaySrc={props.securePaySrc}
          setPageState={(page) => setPage(page)}
          setReceiptState={(receipt) => setReceipt(receipt)}
          baseUrl={props.baseUrl}
        />
      )}
      {page === NavPage.Confirmation && (
        <ConfirmationForm
          setPageState={(page) => setPage(page)}
          receipt={receipt}
          baseUrl={props.baseUrl}
        />
      )}
    </>
  );
};
